import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { staticContent } from "../../content";
import { createIconUrl, mapRange } from "../../utils";
import { IconMask } from "../icon/with-mask";
import { colors } from "../../configs";

import style from "./style.module.css";

const valueRange = [48, 75];

const steps = 4;

export class Passenger extends PureComponent {
  render() {
    const { value, theme, color, disabled } = this.props;

    const min = valueRange[0];
    const max = valueRange[1];
    const parsed = parseFloat(value);
    const inRangeValue = Math.max(min, parsed);
    const pct = mapRange(inRangeValue, min, max, 1, 100);

    return (
      <div
        style={{
          width: "350px",
          maxWidth: "50%",
          background: "transparent",
          position: "absolute",
          padding: "10px",
          right: 0,
          color: "white"
        }}
      >
        <div
          className="subTitle"
          style={{
            paddingBottom: "2px"
          }}
        >
          PASSENGERS IN NETWORK
        </div>
        <div
          style={{
            width: "100%"
          }}
        >
          <div
            style={{
              background: theme.iconBackground,
              height: "15px",
              width: "100%",
              paddingLeft: "1px",
              paddingRight: "1px"
            }}
          >
            <div
              style={{ position: "relative", height: "100%", width: "100%" }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  display: "flex"
                }}
              >
                {Array(steps)
                  .fill()
                  .map((_, i) => (
                    <span
                      key={i}
                      style={{
                        marginTop: "1px",
                        marginBottom: "1px",
                        borderRight:
                          i < steps - 1
                          ? `2px solid ${colors.dark[1]}`
                          : "none",
                        opacity: "0.3",
                        flex: "1"
                      }}
                    />
                  ))}
              </div>
              <div
                style={{
                  position: "absolute",
                  width: `${pct}%`,
                  transition: "width 1s",
                  transitionTimingFunction: "easy-out",
                  height: "100%",
                  background: colors.colors.red,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end"
                }}
              >
                {parsed > 50 && (
                   <span
                     style={{
                       fontSize: "11px",
                       fontWeight: "normal",
                       paddingRight: "3px",
                       color: "white"
                     }}
                     >
                     {parsed + "k"}
                   </span>
                )}
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              fontSize: "11px"
            }}
          >
            <div>{valueRange[0]}k</div>
            <div>{valueRange[1]}k</div>
          </div>
        </div>
      </div>
    );
  }
}

Passenger.propTypes = {
  value: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/passenger/index.js